/* Magic Zoom Plus keyboard accessibility (site audit P1-4).
   Magic Zoom Plus is an admin-managed app embed, enabled on the live PDPs. It
   rebuilds the product gallery but leaves Dawn's native <media-gallery> in the
   DOM, shoved to x=-10000 and still focusable: a keyboard user tabs through
   ~20 invisible stops (a skip link + slider/thumbnail buttons) and MZP's own
   off-screen carousel thumbnails before reaching two unlabeled 30x30 arrow
   buttons. The vendor exposes no accessibility option (checked 2026-07-09), so
   this small progressive enhancement patches it from our side.

   Once MZP has actually mounted it:
     - marks the displaced native gallery inert + aria-hidden (drops the dead
       stops), but only when that gallery is confirmed parked off screen;
     - names MZP's prev/next arrows "Previous image" / "Next image";
     - takes the scrolled-out carousel thumbnails out of the tab order,
       re-syncing as the strip moves.

   Fail-open: if MZP never mounts (embed off, app removed, script blocked) the
   native gallery is left completely untouched and fully focusable. Hit-area
   CSS lives in assets/duo-mzp-a11y.css. */
(function () {
  'use strict';

  if (window.__duoMzpA11y) return;
  window.__duoMzpA11y = true;

  var PREV_LABEL = 'Previous image';
  var NEXT_LABEL = 'Next image';
  var WAIT_MS = 8000;

  // MZP is "mounted" once it has drawn its own figure/expand link or exposed
  // its runtime global.
  function mzpMounted() {
    return !!(document.querySelector('figure.mz-figure, a.MagicZoomPlus') || window.MagicZoom);
  }

  // Write an attribute only when it actually changes, so our own edits never
  // churn the MutationObserver.
  function setAttr(el, name, value) {
    if (el && el.getAttribute(name) !== value) el.setAttribute(name, value);
  }

  // The native gallery is displaced when its box sits fully left of the
  // viewport (MZP parks it near x=-10000). We never hide a gallery that is
  // still on screen, so the MZP-absent path can never lose the real gallery.
  function isDisplaced(el) {
    var r = el.getBoundingClientRect();
    return r.right <= 0 || r.left <= -2000;
  }

  function hideNativeGallery() {
    var gallery = document.querySelector('media-gallery');
    if (gallery && isDisplaced(gallery)) {
      if (!gallery.hasAttribute('inert')) gallery.setAttribute('inert', '');
      setAttr(gallery, 'aria-hidden', 'true');
    }
  }

  function labelArrows() {
    document
      .querySelectorAll('.mcs-button-arrow-prev, .MagicToolboxSlides-arrow.magic-prev')
      .forEach(function (el) { setAttr(el, 'aria-label', PREV_LABEL); });
    document
      .querySelectorAll('.mcs-button-arrow-next, .MagicToolboxSlides-arrow.magic-next')
      .forEach(function (el) { setAttr(el, 'aria-label', NEXT_LABEL); });
  }

  // Off-screen carousel thumbnails must leave the tab order; the visible ones
  // keep it. The clip viewport is .mcs-wrapper (overflow:hidden); a thumbnail
  // whose box does not overlap it horizontally has been scrolled out of sight.
  function syncThumbs() {
    document.querySelectorAll('.mz-thumb').forEach(function (thumb) {
      var clip = thumb.closest('.mcs-wrapper');
      var visible;
      if (clip) {
        var t = thumb.getBoundingClientRect();
        var c = clip.getBoundingClientRect();
        visible = t.right > c.left + 1 && t.left < c.right - 1;
      } else {
        var tr = thumb.getBoundingClientRect();
        visible = tr.right > 0 && tr.left < window.innerWidth;
      }
      if (visible) {
        if (thumb.getAttribute('tabindex') === '-1') thumb.removeAttribute('tabindex');
      } else {
        setAttr(thumb, 'tabindex', '-1');
      }
    });
  }

  var applyScheduled = false;
  function scheduleApply() {
    if (applyScheduled) return;
    applyScheduled = true;
    requestAnimationFrame(function () {
      applyScheduled = false;
      apply();
    });
  }

  function apply() {
    hideNativeGallery();
    labelArrows();
    syncThumbs();
  }

  // Re-run on the changes MZP makes to its own carousel (arrow clicks translate
  // the strip; variant swaps rebuild it). attributeFilter deliberately omits
  // tabindex so our own thumb edits cannot re-trigger the observer.
  function watch() {
    var root = document.querySelector('.MagicToolboxContainer') || document.body;
    var mo = new MutationObserver(scheduleApply);
    mo.observe(root, {
      subtree: true,
      childList: true,
      attributes: true,
      attributeFilter: ['style', 'class'],
    });
    root.addEventListener('transitionend', scheduleApply, true);
  }

  function start() {
    apply();
    watch();
  }

  // Wait for MZP however long it takes to inject, then stop waiting so the
  // no-MZP path costs nothing.
  function boot() {
    if (mzpMounted()) { start(); return; }
    var mzMo = new MutationObserver(function () {
      if (mzpMounted()) {
        mzMo.disconnect();
        start();
      }
    });
    mzMo.observe(document.documentElement, { subtree: true, childList: true });
    setTimeout(function () {
      mzMo.disconnect();
      if (mzpMounted()) start();
    }, WAIT_MS);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
